module.exports = __webpack_public_path__ + "static/media/Hero_Image_Mobile_5.8941d874.jpg";